import { BaseDisplayer } from './BaseDisplayer';
import { ValueType } from '../FormatterTypes';

class TEDDisplayDefault extends BaseDisplayer {
  public static getInstance(): BaseDisplayer {
    return this.instance ? this.instance : (this.instance = new this());
  }
  private static instance: BaseDisplayer;

  defaultParams() {
    return '';
  }

  display(
    value: ValueType,
    displayText: boolean = true,
    params: string = ''
  ): string {
    if (value === null || value === undefined) {
      return '';
    }
    return value.toString();
  }
}

export { TEDDisplayDefault };
